import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
  {
    _id: 1005,
    title: "Collection",
    link: "/journal",
  },
];
// =================== NavBarList End here ======================

// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "Modern Sofa Set",
    price: "850.00",
    color: "Velvet Grey",
    badge: true,
    des: "Experience luxury with our Kadees exclusive velvet sofa set, designed for modern living rooms.",
  },
  {
    _id: "202",
    img: newArrFour,
    productName: "Luxury Tea Table",
    price: "180.00",
    color: "Oak Wood",
    badge: true,
    des: "A perfect blend of nature and craft, this oak tea table brings warmth to your home.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "Golden Wall Clock",
    price: "45.00",
    color: "Gold",
    badge: true,
    des: "Stay on time with style. Our golden wall clock is a masterpiece of minimalist design.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "Designer Lamps",
    price: "120.00",
    color: "Matte Black",
    badge: true,
    des: "Light up your workspace with the Kadees matte black designer lamp collection.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  {
    _id: 1001,
    img: spfOne,
    productName: "Modern Sofa Set",
    price: "850.00",
    color: "Velvet Grey",
    badge: true,
    des: "Handcrafted comfort for your living room from Kadees.",
  },
  {
    _id: 1002,
    img: spfTwo,
    productName: "Tea Table",
    price: "180.00",
    color: "Gray",
    badge: true,
    des: "Minimalist oak wood tea table.",
  },
  {
    _id: 1003,
    img: spfThree,
    productName: "Luxury Headset",
    price: "125.00",
    color: "Mixed",
    badge: true,
    des: "High-quality sound for your home office.",
  },
  {
    _id: 1004,
    img: spfFour,
    productName: "Sun Glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Kadees limited edition eyewear.",
  },
  {
    _id: 1005,
    img: bestSellerOne,
    productName: "Flower Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Decorative flower base for modern tables.",
  },
  {
    _id: 1006,
    img: bestSellerTwo,
    productName: "New Backpack",
    price: "180.00",
    color: "Gray",
    badge: false,
    des: "Durable travel backpack from Kadees.",
  },
  {
    _id: 1007,
    img: bestSellerThree,
    productName: "Household Materials",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Essential tools for home maintenance.",
  },
  {
    _id: 1008,
    img: bestSellerFour,
    productName: "Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Premium leather travel bag.",
  },
  {
    _id: 1009,
    img: newArrOne,
    productName: "Round Table Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Vintage style table clock for decor.",
  },
  {
    _id: 1010,
    img: newArrTwo,
    productName: "Smart Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Modern technology meets elegant design.",
  },
  {
    _id: 1011,
    img: newArrThree,
    productName: "Cloth Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Organize your room with style.",
  },
  {
    _id: 1012,
    img: newArrFour,
    productName: "Baby Toys",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Safe and fun toys for the little ones.",
  },
  {
    _id: 1013,
    img: newArrTwo,
    productName: "Modern Watch",
    price: "260.00",
    color: "Mixed",
    badge: false,
    des: "Classic watch from Kadees collection.",
  },
  {
    _id: 1014,
    img: newArrTwo,
    productName: "Smart Watch v2",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Upgraded tech for your wrist.",
  },
  {
    _id: 1015,
    img: newArrFour,
    productName: "Small Baby Toys",
    price: "60.00",
    color: "Mixed",
    badge: false,
    des: "Educational toys for kids.",
  },
  {
    _id: 1016,
    img: newArrTwo,
    productName: "Smart Watch Gold",
    price: "350.00",
    color: "Gold",
    badge: true,
    des: "Luxury smart watch edition.",
  },
  {
    _id: 1017,
    img: bestSellerFour,
    productName: "Leather Travel Bag",
    price: "220.00",
    color: "Black",
    badge: false,
    des: "Travel in style with Kadees.",
  },
  {
    _id: 1018,
    img: newArrOne,
    productName: "Minimal Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Sleek clock design for office.",
  },
  {
    _id: 1019,
    img: newArrTwo,
    productName: "Smart Watch Sport",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Perfect companion for athletes.",
  },
  {
    _id: 1020,
    img: newArrThree,
    productName: "Laundry Basket",
    price: "80.00",
    color: "Mixed",
    badge: true,
    des: "Premium quality cloth basket.",
  },
  {
    _id: 1021,
    img: spfThree,
    productName: "Gaming Headphones",
    price: "95.00",
    color: "Mixed",
    badge: true,
    des: "Immersive sound experience.",
  },
  {
    _id: 1022,
    img: spfFour,
    productName: "Dark Glasses",
    price: "120.00",
    color: "Black",
    badge: true,
    des: "UV protection in style.",
  },
  {
    _id: 1023,
    img: bestSellerOne,
    productName: "White Flower Base",
    price: "40.00",
    color: "White",
    badge: true,
    des: "Elegant base for your flowers.",
  },
  {
    
    _id: 1024,
    img: spfOne,
    productName: "Kadees Cap",
    price: "35.00",
    color: "Black",
    badge: true,
    des: "Streetwear fashion from Kadees.",
  },
  {
    _id: 1025,
    img: spfTwo,
    productName: "Wood Table",
    price: "180.00",
    color: "Brown",
    badge: true,
    des: "Sturdy wood table for home decor.",
  },
  {
    _id: 1026,
    img: spfThree,
    productName: "Studio Headphones",
    price: "250.00",
    color: "Mixed",
    badge: true,
    des: "Professional audio gear.",
  },
  {
    _id: 1027,
    img: spfFour,
    productName: "Aviator Glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Timeless eyewear design.",
  },
  {
    _id: 1028,
    img: bestSellerOne,
    productName: "Ceramic Base",
    price: "55.00",
    color: "Gray",
    badge: true,
    des: "Handmade ceramic flower base.",
  },
  {
    _id: 1029,
    img: bestSellerTwo,
    productName: "Hiking Backpack",
    price: "190.00",
    color: "Gray",
    badge: false,
    des: "Ready for the mountains.",
  },
  {
    _id: 1030,
    img: bestSellerThree,
    productName: "Home Decor Kit",
    price: "75.00",
    color: "Mixed",
    badge: true,
    des: "Everything you need to decorate.",
  },
  {
    _id: 1031,
    img: bestSellerFour,
    productName: "Business Bag",
    price: "280.00",
    color: "Black",
    badge: false,
    des: "Professional bag for executives.",
  },
  {
    _id: 1032,
    img: newArrOne,
    productName: "Silver Table Clock",
    price: "60.00",
    color: "Silver",
    badge: true,
    des: "Modern silver finish clock.",
  },
  {
    _id: 1033,
    img: newArrTwo,
    productName: "Smart Watch Pro",
    price: "450.00",
    color: "Black",
    badge: true,
    des: "The ultimate smart watch experience.",
  },
  {
    _id: 1034,
    img: newArrThree,
    productName: "Eco Basket",
    price: "40.00",
    color: "Mixed",
    badge: true,
    des: "Environmentally friendly materials.",
  },
  {
    _id: 1035,
    img: newArrFour,
    productName: "Soft Baby Toys",
    price: "30.00",
    color: "Mixed",
    badge: false,
    des: "Extra soft for safe play.",
  },
  {
    _id: 1036,
    img: newArrTwo,
    productName: "Watch v3",
    price: "160.00",
    color: "Mixed",
    badge: false,
    des: "Kadees daily wear watch.",
  },
  {
    _id: 1037,
    img: newArrFour,
    productName: "Educational Toys",
    price: "90.00",
    color: "Mixed",
    badge: false,
    des: "Learn while playing.",
  },
  {
    _id: 1038,
    img: newArrTwo,
    productName: "Digital Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "High precision digital timing.",
  },
  {
    _id: 1039,
    img: bestSellerFour,
    productName: "Weekend Bag",
    price: "120.00",
    color: "Black",
    badge: false,
    des: "Perfect for short trips.",
  },
  {
    _id: 1040,
    img: newArrOne,
    productName: "Desk Clock",
    price: "44.00",
    color: "Black",
    badge: true,
    des: "Elegant desk accessory.",
  },
  {
    _id: 1041,
    img: newArrTwo,
    productName: "Tech Watch",
    price: "250.00",
    color: "Black",
    badge: true,
    des: "Kadees technology on your wrist.",
  },
  {
    _id: 1042,
    img: newArrThree,
    productName: "Large Basket",
    price: "100.00",
    color: "Mixed",
    badge: true,
    des: "Spacious storage for your home.",
  },
  {
    _id: 1043,
    img: spfThree,
    productName: "Bass Headphones",
    price: "85.00",
    color: "Mixed",
    badge: true,
    des: "Deep bass for music lovers.",
  },
  {
    _id: 1044,
    img: spfFour,
    productName: "Sport Glasses",
    price: "150.00",
    color: "Black",
    badge: true,
    des: "Stay active and protected.",
  },
  {
    _id: 1045,
    img: bestSellerOne,
    productName: "Modern Base",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "A piece of art for your home.",
  },
  {
    _id: 1046,
    img: spfOne,
    productName: "Street Cap",
    price: "35.00",
    color: "Black",
    badge: true,
    des: "Final addition to your outfit.",
  },
];
// =================== PaginationItems End here =================